import React from 'react';
import { uniqBy } from 'lodash';

// Components
import MobileComparisonMatrix from './mobile/MobileComparisonMatrix';
import DesktopComparisonMatrix from './desktop/DesktopComparisonMatrix';

// Types
import { QuoteQuality } from '../../../../../../../types/Quotes';
import { useLouiseSelector } from '../../../../store/redux/store';
import useMobileBreakpoints from '../../../../../../common/src/hooks/useMobileBreakpoints';
import useComparisonQuotes from '../../hooks/useComparisonQuotes';

interface Props {
  riskObject: string;
  isComparisonActive: boolean;
  setIsComparisonActive: (arg0: boolean) => void;
  addToSelectedOffers: (arg0: string) => void;
  removeFromSelectedOffers: (id?: string) => void;
}

const ComparisonMatrix: React.FC<React.PropsWithChildren<Props>> = ({
  riskObject,
  isComparisonActive,
  setIsComparisonActive,
  addToSelectedOffers,
  removeFromSelectedOffers,
}) => {
  const { isLaptop } = useMobileBreakpoints();

  const comparisonMatrixOffers = useLouiseSelector(
    (state) => state.offers.comparisonMatrixOffers,
  );

  const { comparisonQuotes, isFetched } = useComparisonQuotes(riskObject);

  const options = uniqBy(
    ([] as (QuoteQuality | undefined)[]).concat(
      ...comparisonQuotes.map(({ quality }) => quality),
    ),
    'key',
  ).filter((item) => !!item);

  if (
    !isFetched ||
    !comparisonMatrixOffers[riskObject] ||
    comparisonMatrixOffers[riskObject]?.length < 2
  )
    return null;

  return (
    <>
      {isLaptop ? (
        <DesktopComparisonMatrix
          riskObject={riskObject}
          addToSelectedOffers={addToSelectedOffers}
          removeFromSelectedOffers={removeFromSelectedOffers}
          setIsComparisonActive={setIsComparisonActive}
          isComparisonActive={isComparisonActive}
          quotes={comparisonQuotes}
          options={options}
        />
      ) : (
        <MobileComparisonMatrix
          riskObject={riskObject}
          addToSelectedOffers={addToSelectedOffers}
          removeFromSelectedOffers={removeFromSelectedOffers}
          setIsComparisonActive={setIsComparisonActive}
          quotes={comparisonQuotes}
          isComparisonActive={isComparisonActive}
          options={options}
        />
      )}
    </>
  );
};

export default ComparisonMatrix;
